export const RoofType = Object.freeze({
  SHINGLE: 1,
  STANDING_SEAM:  2,
  R_PANEL: 5,
  TILE : 3,
  OTHERS : 4,
  GABLE: 6,
  CONCRETE: 7,
});

export const RmRoofType = Object.freeze({
  MINERAL_CAP : 5,
  EPDM : 6,
  TPO : 7,
  PVC : 8,
  OTHER : 9,
  FINE_GRAVEL : 13,
  HONED_CONCRETE : 14,
  PAINTED_CONCRETE : 15,
  BROOMED_CONCRETE : 16,
  KEE : 17,
  TPA : 18,
  APP : 19,
  SBS : 20,
  ACRYLIC : 21,
  COATED : 22,
});

export const DEFAULT_VERIFIED_FLYOUTS_DATA = {
  'module-selection': {checked: false, error: false},
  'location-and-loads': {checked: false, error: false},
  'rail-system': {checked: false, error: false},
  'additional-user-inputs': {checked: false, error: false},
};

export const DEFAULT_VERIFIED_FLYOUTS_DATA_FOR_AURORA_IMPORTED_PROJECTS = {
  'module-selection': {checked: true, error: false},
  'location-and-loads': {checked: false, error: false},
  'rail-system': {checked: false, error: false},
  'additional-user-inputs': {checked: true, error: false},
};
